import i18n from '@/i18n/config';
import { CreateShapeCommand } from '../../../../core/commands/CreateShapeCommand';
import { getTableSchema } from './tableSchemas.registry';
import { resolveTableShapeConfigFromSchema } from './tableSchemaShapeConfig';

const translateSwimlaneLaneText = (schemaId: string, text: string): string => {
  if (schemaId !== 'swimlane-vertical' && schemaId !== 'swimlane-horizontal') {
    return text;
  }
  const trimmed = text.trim();
  const match = /^Lane\s+(\d+)$/i.exec(trimmed);
  if (!match) return text;
  const n = Number.parseInt(match[1], 10);
  return i18n.t('diagram:table.swimlaneLane', { n, defaultValue: text }) as string;
};

type Position = { x: number; y: number };

export const createTableFromSchema = (schemaId: string, position: Position): CreateShapeCommand => {
  const schema = getTableSchema(schemaId);
  if (!schema) {
    throw new Error(`Unknown table schema: ${schemaId}`);
  }

  const { width, height, attrs } = resolveTableShapeConfigFromSchema(schema);

  if (attrs.cellText && typeof attrs.cellText === 'object') {
    const translated: Record<string, string> = {};
    for (const [key, value] of Object.entries(attrs.cellText as Record<string, string>)) {
      translated[key] = translateSwimlaneLaneText(schema.id, value);
    }
    attrs.cellText = translated;
  }

  return new CreateShapeCommand({
    type: 'table',
    x: position.x,
    y: position.y,
    width,
    height,
    category: 'basic',
    attrs,
  });
};
